import { useEffect, useState } from "react";
import { api } from "../api";
import type { Tier } from "../../server/types";

interface BackupItem { key: string; size: number; lastModified: string; }

function fmtSize(bytes: number): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let v = bytes; let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v >= 100 ? 0 : 1)} ${units[i]}`;
}

export default function BackupsPage() {
  const [data, setData] = useState<Record<Tier, BackupItem[]> | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function refresh() {
    setBusy(true); setErr(null);
    try { setData((await api.getBackups()).backups); }
    catch (e) { setErr((e as Error).message); }
    finally { setBusy(false); }
  }
  useEffect(() => { void refresh(); }, []);

  async function download(key: string) {
    try {
      const { url } = await api.getDownloadUrl(key);
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) { setErr((e as Error).message); }
  }

  const tiers: Tier[] = ["daily", "weekly", "monthly"];

  return (
    <>
      <h2>Backups in S3</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <button onClick={refresh} disabled={busy}>{busy ? "Loading…" : "Refresh"}</button>
        <span className="muted">Listed live from the configured bucket.</span>
      </div>

      {err && <div className="error-box" style={{ marginBottom: 16 }}>{err}</div>}

      {tiers.map((t) => (
        <div className="card" key={t} style={{ padding: 0 }}>
          <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--border)" }}>
            <span className={`badge ${t}`}>{t}</span>
            <span className="muted" style={{ marginLeft: 8 }}>
              {data ? `${data[t].length} object(s)` : "loading…"}
            </span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Key</th><th>Size</th><th>Last modified</th><th></th>
              </tr>
            </thead>
            <tbody>
              {data && data[t].length === 0 && (
                <tr><td colSpan={4} className="muted" style={{ padding: 16, textAlign: "center" }}>No objects in this tier yet.</td></tr>
              )}
              {data?.[t].map((o) => (
                <tr key={o.key}>
                  <td><code>{o.key}</code></td>
                  <td>{fmtSize(o.size)}</td>
                  <td>{new Date(o.lastModified).toLocaleString()}</td>
                  <td style={{ textAlign: "right" }}>
                    <button onClick={() => download(o.key)}>Download</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
}
